import './preview-help.dialog.scss'
import {Opportunity} from "../../../opportunities/model/Opportunity";
import {OpportunityPreRenderServiceName} from "../../../utils/names/serviceNames";
import {OpportunityPreRenderService} from "../../service/OpportunityPreRenderService";
import {ActionTypes} from "../../../action_status/model/ActionType";
import {PreviewContentType} from "./model/PreviewContentType";
import {LoaderOptions} from "../../../loader/model/LoaderOptions";
import {EmailPreviewService, EmailPreviewServiceName} from "modules/user_settings/service/EmailPreviewService";

export class PreviewHelpDialog {

    static instance = (opportunity: Opportunity, actionType: ActionTypes, previewContentType: PreviewContentType) => ({
        template: require('./preview-help.dialog.html'),
        controller: [
            '$mdDialog',
            '$scope',
            'opportunity',
            'actionType',
            'previewContentType',
            OpportunityPreRenderServiceName,
            EmailPreviewServiceName,
            PreviewHelpDialog
        ],
        controllerAs: '$ctrl',
        multiple: true,
        clickOutsideToClose: true,
        locals: {
            opportunity: opportunity,
            actionType: actionType,
            previewContentType: previewContentType
        }
    })

    private dialogStyle: string;
    private contentUrl: string;
    private contentText: string;
    private loaderOptions: LoaderOptions;

    constructor(private $mdDialog: angular.material.IDialogService,
                private $scope: angular.IScope,
                private opportunity: Opportunity,
                private actionType: ActionTypes,
                private previewContentType: PreviewContentType,
                private opportunityPreRenderService: OpportunityPreRenderService,
                private emailPreviewService: EmailPreviewService
    ) {
    }

    $onInit() {
        this.initDialogStyle();
        this.initLoaderOptions();
        this.initContent();

    }

    private initDialogStyle() {
        switch (this.previewContentType) {
            case PreviewContentType.IFRAME:
                this.dialogStyle = 'iframe-preview-dialog';
                break;
            case PreviewContentType.TEXT:
                this.dialogStyle = 'text-preview-dialog';
                break;
        }
    }

    private initLoaderOptions() {
        switch (this.previewContentType) {
            case PreviewContentType.IFRAME: {
                this.loaderOptions = {
                    showLoader: false
                };
                break;
            }
            case PreviewContentType.TEXT: {
                this.loaderOptions = {
                    showLoader: true
                }
                break;
            }
            default:
                throw new Error(`unexpected PreviewContentType ${this.previewContentType}`);

        }
    }

    close = () => {
        this.$mdDialog.hide();
    }

    private initContent() {
        switch (this.previewContentType) {
            case PreviewContentType.IFRAME:
                this.initContentUrl();
                break;
            case PreviewContentType.TEXT:
                this.initContentText()
                break;
        }
    }

    private initContentUrl() {
        this.loaderOptions.showLoader = true;
        this.contentUrl = this.opportunityPreRenderService.getOpportunityPreRenderUrl(this.opportunity, this.actionType);
    }

    private initContentText() {
        this.opportunityPreRenderService.getOpportunityPreRender(this.opportunity, this.actionType)
            .then(text => this.contentText = text)
            .then(() => this.loaderOptions.showLoader = false);
    }

    onIframeLoad() {
        console.log("Entered")
        this.$scope.$apply(() => {
            this.loaderOptions.showLoader = false;
        })
    }

    showRegenerateButton = () => this.actionType == ActionTypes.EMAIL || ActionTypes.TWILIO_SMS;

    regenerate() {
        this.contentUrl = null;
        this.contentText = null;
        this.loaderOptions.showLoader = true;

        this.emailPreviewService.updatePreview(this.opportunity.id, this.actionType)
            .then(() => {
                this.initContent()
                this.loaderOptions.showLoader = false;
            });
    }

}